import { render, staticRenderFns } from "./platcontract-info.vue?vue&type=template&id=36f7128b&"
import script from "./platcontract-info.vue?vue&type=script&lang=js&"
export * from "./platcontract-info.vue?vue&type=script&lang=js&"
import style0 from "./platcontract-info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports